import {
  DEFAULT_STANDARD_CONTRACT_TEMPLATE_ID,
  PLATFORM_PREBUILT_ERC1155_TEMPLATE_ID,
  PLATFORM_PREBUILT_ERC20_TEMPLATE_ID,
  suggestStandardContractTemplateId
} from './standardContractTemplates';

/**
 * Normalize catalog token standard from API (string enum, numeric enum, or legacy labels).
 * @param {unknown} raw
 * @returns {'ERC721'|'ERC1155'|'ERC20'}
 */
export function normalizeTokenStandardKey(raw) {
  if (raw === null || raw === undefined || raw === '') return 'ERC721';
  if (typeof raw === 'number') {
    if (raw === 2) return 'ERC1155';
    if (raw === 3) return 'ERC20';
    return 'ERC721';
  }
  const s = String(raw).trim();
  const compact = s.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  if (compact === 'ERC1155' || s === '2') return 'ERC1155';
  if (compact === 'ERC20' || s === '3') return 'ERC20';
  if (compact === 'ERC721' || s === '1') return 'ERC721';
  if (/^ERC-?1155$/i.test(s)) return 'ERC1155';
  if (/^ERC-?20$/i.test(s)) return 'ERC20';
  return 'ERC721';
}

/**
 * Pick embedded contract template for mint/deploy flows from the asset class record.
 * @param {{ tokenStandard?: string, category?: string } | null | undefined} assetClass
 */
export function resolveContractTemplateIdForAssetClass(assetClass) {
  const std = normalizeTokenStandardKey(assetClass?.tokenStandard);
  if (std === 'ERC20') return PLATFORM_PREBUILT_ERC20_TEMPLATE_ID;
  if (std === 'ERC1155') return PLATFORM_PREBUILT_ERC1155_TEMPLATE_ID;
  return suggestStandardContractTemplateId(assetClass?.category) || DEFAULT_STANDARD_CONTRACT_TEMPLATE_ID;
}
